module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-f2ccd86ea8cfe753efd1bdc5a0039b3c.png";